import React from "react";
import { Translate } from "react-redux-i18n";
import { connect } from "react-redux";
import { Icon } from "@blueprintjs/core";
import FormatedPrice from "../../components/FormatedPrice";
import StickyBox from "react-sticky-box";
import { fetchSuggestionInCollection } from "../../store/circle_suggestion/operations";
import { selectCollection } from "../../store/home_ui/creators";
import LoadingIndicator from "../../components/LoadingIndicator";
import { Converter } from "react-showdown";
import {
  getSuggestionWithId,
  loadingInitialSuggestionsForSelectedCollection
} from "../../store/circle_suggestion/selectors";
import { navigate } from "../../store/navigation/operations";

import Breadcrumb from "../../components/Breadcrumb";

import CustomIcon from "../../components/CustomIcon";
import CircleImage from "../../components/Image/CircleImage";
import { SuggestionHelmet } from "../../components/helmets";
import BuyButton from "../BuyWithFriends/BuyButton";
class SuggestionPresentation extends React.Component {
  state = {
    expanded: false
  };
  mdConverter = new Converter();

  componentDidMount() {
    this.props.selectCollection(this.props.collection);
    this.props.fetchSuggestionInCollection(this.props.collection, true, this.props.suggestionId);
  }

  render() {
    const breadcrumbItems = this.props.circle
      ? [
          {
            onClick: () => {
              this.props.navigate("/");
            },
            icon: "document",
            text: <Translate value="menu.home" />
          },
          {
            onClick: () => {
              this.props.navigate(`/collection/${this.props.collection}`);
            },
            icon: "document",
            text: this.props.collection
          },
          { icon: "document", text: this.props.circle.name }
        ]
      : [];
    return (
      <>
        <Breadcrumb breadcrumbItems={breadcrumbItems} />
        <section>
          <div className="main-container">
            <div className="content-wrapper">
              {this.props.loadingCircle && <LoadingIndicator />}
              {this.props.circle && (
                <>
                  <SuggestionHelmet suggestion={this.props.circle} />
                  <div className="product-details">
                    <div className="product-image">
                      {this.props.circle && (
                        <CircleImage src={this.props.circle.images[0].url} size="medium" alt={this.props.circle.name} />
                      )}
                    </div>
                    <div className="product-details-wrapper">
                      <div className="product-meta">
                        <div className={`product-description ${this.state.expanded ? "expanded" : "collapsed"}`} >
                          <div className="old-price">
                            <FormatedPrice
                              value={this.props.circle.total_price}
                              currency_type={this.props.circle.currency}
                            />
                          </div>
                          <h1 className="bp3-heading">{this.props.circle.name}</h1>
                          <a href={this.props.circle.product_url} target="_blank" rel="noopener noreferrer" className="product-url">
                            <Icon icon="link" iconSize="14" className="icon" />
                            {this.props.circle.product_url}
                          </a>
                          <hr className="separator" />
                          <div
                            className="mobile-content-expand"
                            onClick={() => {
                              this.setState({ expanded: true });
                            }}>
                            <Icon icon="more" iconSize="24" className="icon" />
                          </div>
                          {this.mdConverter.convert(this.props.circle.short_description)}
                          {this.mdConverter.convert(this.props.circle.description)}
                        </div>
                        <StickyBox offsetTop={80} offsetBottom={80}>
                          <div className="product-side-info">
                            <h2>
                              <Translate value="circle.ready_to_co_own" />
                            </h2>
                            <div className="product-split">
                              <div className="split-item product-owners">
                                <Icon icon="people" iconSize="24" className="icon" />
                                <strong>{this.props.circle.suggested_members_no}</strong>
                                <Translate value="circle.co_owners" />
                              </div>
                              <div className="split-item product-price">
                                <CustomIcon name="money-bills" size="24" className="icon" />
                                <strong>
                                  <FormatedPrice
                                    value={this.props.circle.total_price / this.props.circle.suggested_members_no}
                                    currency_type={this.props.circle.currency}
                                  />
                                </strong>
                                <Translate value="circle.per_person" />
                              </div>
                            </div>
                            {/* <div className="product-cta">
                              <CreateNewCircleDecorator
                                collection={this.props.collection}
                                suggestionId={this.props.suggestionId}>
                                <Button intent="primary" className="cta" fill={true}>
                                  <Translate value="circle.lets_start" />
                                </Button>
                              </CreateNewCircleDecorator>
                            </div> */}
                            <BuyButton product={this.props.circle} />
                          </div>
                        </StickyBox>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </section>
      </>
    );
  }
}

const mapStateToProps = (state, props) => ({
  loadingCircle: loadingInitialSuggestionsForSelectedCollection(state, true),
  circle: getSuggestionWithId(state, props.suggestionId, true)
});

const mapDispatchToProps = dispatch => ({
  selectCollection: collection => dispatch(selectCollection(collection)),
  fetchSuggestionInCollection: (collection, featured, id) =>
    dispatch(fetchSuggestionInCollection(collection, featured, id)),
  navigate: to => dispatch(navigate(to))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuggestionPresentation);
